

export default function Login() {
    return (
        <>
            <main>
                <div class="min-h-screen py-6 flex flex-col justify-center sm:py-12">
                    <div class="relative py-3 sm:max-w-xl sm:mx-auto">
                        <div
                            class="absolute inset-0 bg-gradient-to-r from-blue-300 dark:from-blue-700 to-blue-600 dark:to-blue-900 shadow-lg transform -skew-y-6 sm:skew-y-0 sm:-rotate-6 sm:rounded-3xl">
                        </div>
                        <div class="relative px-4 py-10 bg-secondary-light dark:bg-secondary-dark shadow-lg sm:rounded-3xl sm:p-20">
                            <div class="max-w-md mx-auto">
                                <form action="post">
                                    <div>
                                        <h1 class="text-2xl font-semibold">Disconomy'e Giriş Yap</h1>
                                    </div>
                                    <div class="divide-y divide-gray-200">
                                        <div class="py-8 text-base leading-6 space-y-4 text-gray-700 dark:text-gray-100 sm:text-lg sm:leading-7">
                                            <div class="relative">
                                                <input autocomplete="off" type="email" className="peer dark:bg-secondary-dark placeholder-transparent h-10 w-full border-b-2 border-gray-300 text-gray-900 dark:text-white focus:outline-none focus:borer-rose-600" placeholder="Email address" />
                                                <label for="email" class="pointer-events-none absolute cursor-text left-0 -top-3.5 text-gray-600 dark:text-gray-100 text-sm peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-440 peer-placeholder-shown:top-2 transition-all peer-focus:-top-3.5 peer-focus:text-gray-600 dark:peer-focus:text-gray-100 peer-focus:text-sm">E-Mail</label>
                                            </div>
                                            <div class="relative">
                                                <input autocomplete="off" type="password" className="peer dark:bg-secondary-dark placeholder-transparent h-10 w-full border-b-2 border-gray-300 text-gray-900 dark:text-white focus:outline-none focus:borer-rose-600" placeholder="Password" />
                                                <label for="password" class="pointer-events-none absolute cursor-text left-0 -top-3.5 text-gray-600 dark:text-gray-100 text-sm peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-440 peer-placeholder-shown:top-2 transition-all peer-focus:-top-3.5 peer-focus:text-gray-600 dark:peer-focus:text-gray-100 peer-focus:text-sm">Şifre</label>
                                            </div>
                                            <div class="relative">
                                                <button class="bg-blue-500 text-white rounded-md px-2 py-1">Giriş yap</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    )
}